import { useRouter } from 'next/router'
import { Button } from 'react-bootstrap'
import { FaLink } from 'react-icons/fa'
import { useAuthState } from '../firebase/hooks'
import { Designed } from '../types'
import { logEvent } from '../utils'
import { usePopupMessage } from './messenger'

type Props = {
  path?: string
}

export const CopyLinkButton = ({ path, ...designProps }: Designed<Props>) => {
  const router = useRouter()
  const { user } = useAuthState()
  const { setPopupMessage } = usePopupMessage()
  return (
    <Button
      {...designProps}
      variant="link"
      onClick={async () => {
        if (process.env.NEXT_PUBLIC_HOST === undefined) {
          throw Error('missing NEXT_PUBLIC_HOST.')
        }
        await navigator.clipboard.writeText(
          `${process.env.NEXT_PUBLIC_HOST}${
            path !== undefined ? path : router.asPath
          }`
        )
        logEvent('tap_copy_url_button', { uid: user?.uid })
        setPopupMessage('URLをコピーしました。')
      }}
    >
      <FaLink className="text-muted" />
    </Button>
  )
}
